import { TypeOf, z } from 'zod';
import { HttpStatusCodeSchema, buildResponse } from './global';

const DeleteScheduleDataSchema = z.object({
  status: HttpStatusCodeSchema,
});

export const DeleteScheduleResponseSchema =
  buildResponse<TypeOf<typeof DeleteScheduleDataSchema>>(DeleteScheduleDataSchema);

export type DeleteScheduleResponse = TypeOf<typeof DeleteScheduleResponseSchema>;
